module.exports = __webpack_public_path__ + "static/media/linedow.f6e7ac95.svg";